export default __webpack_public_path__ + "static/media/dashed-line.61202d6e.svg";